<div class="card min-w-[320px] max-w-[480px]">
    <div *ngIf="!hasRequested; else thanks">
        <div class="flex flex-row m-0">
            <p-button
              icon="ri-arrow-left-line"
              (onClick)="goToLogin()"
              [outlined]="true"
              [rounded]="true"
              styleClass="p-button-rounded p-button-outlined"
            ></p-button>
          </div>
          <h2 class="mt-4">Reestablece tu contraseña</h2>
        <input type="text" pInputText [(ngModel)]="email" class="w-full" />
        <div class="flex mt-8 justify-end">
            <p-button (onClick)="resetPassword()" label="Solicitar enlace"></p-button>
        </div>
    </div>
    <ng-template #thanks>
        <div class="flex flex-row m-0">
            <p-button
              icon="ri-arrow-left-line"
              (onClick)="goToLogin()"
              [outlined]="true"
              [rounded]="true"
              styleClass="p-button-rounded p-button-outlined"
            ></p-button>
          </div>
          <h2 class="mt-4">Revisa tu bandeja de entrada</h2>
          <p>Te hemos enviado un enlace para que puedas reestablecer tu contraseña</p>
    </ng-template>
  </div>